document.addEventListener('DOMContentLoaded', () => {

  const menu = document.querySelector('[data-nmh]');
  const trigger = document.querySelector('[data-nmh-trigger]');
  const overlay = document.querySelector('[data-nmh-overlay]');
  const close = document.querySelector('[data-nmh-close]');
  const search = document.querySelector('[data-nmh-search]');

  if (!menu) return;

  /* ==========================
     DRAWER
  ========================== */

  function openMenu() {
    menu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    menu.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  trigger?.addEventListener('click', openMenu);
  close?.addEventListener('click', closeMenu);
  overlay?.addEventListener('click', closeMenu);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      closeMenu();
    }
  });

  /* ==========================
     ABRIR POPUP PESQUISA
  ========================== */

search?.addEventListener('click', () => {

  closeMenu();

  const themeSearch =
    document.querySelector(
      'search-button button'
    );

  if (!themeSearch) return;

  themeSearch.click();

});

  /* ==========================
     SUBMENUS
  ========================== */

  document
    .querySelectorAll('.nmh__item.has-submenu')
    .forEach(item => {

      const openSubmenu = e => {

        e.preventDefault();

        const opened =
          item.classList.contains('is-open');

        document
          .querySelectorAll(
            '.nmh__item.has-submenu.is-open'
          )
          .forEach(el => {
            if (el !== item) {
              el.classList.remove('is-open');
            }
          });

        item.classList.toggle(
          'is-open',
          !opened
        );

      };

      item
        .querySelector('[data-submenu-link]')
        ?.addEventListener(
          'click',
          openSubmenu
        );

      item
        .querySelector('[data-submenu-toggle]')
        ?.addEventListener(
          'click',
          openSubmenu
        );

    });

});